/*
  Create by BaiZhiming 2015-11-03
*/
"use strict";
angular.module("util.ueditor", ['util.ueditorConfig', 'util.ueditorServiceModule', 'util.ueditorServiceBtnModule']).directive("ueditor", ["$timeout", "$sce", 'editPictureService', "$q", "$modal", "$interval", "localStorageService", "trsUeditorConfigService", "modalDialog", "ueditorService", "$compile", "$window", "ueditorBtnService", "playVideoService", "httpService", function($timeout, $sce, editPictureService, $q, $modal, $interval, localStorageService, trsUeditorConfigService, modalDialog, ueditorService, $compile, $window, ueditorBtnService, playVideoService, httpService) {
	return {
		restrict: 'E',
		scope: {
			list: "=",
			versionid: "=",
			customButtonFn: "&",
			customButton: "=",
			infullscreen: "=", //是否处在全屏状态
			type: "@",
			hasContent: "="
		},
		replace: true,
		template: "<div><script id='ueditor' style='width:100%;position:relative'></script><div class='trs_ueditor_selectionNum'>选中字数统计</div></div>",
		link: function(scope, element, attrs, ctrl) {
			var tempArrary = [];
			var editorToolBar = ueditorService.getToolBar();
			if(scope.type === "newNotice") {
				editorToolBar.topOffset = 160;
			}
			editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], [33, 41]);
			var ue = UE.getEditor('ueditor', editorToolBar);
			ue.ready(function() {
				scope.list.articleHtmlCon = scope.list.articleHtmlCon.replace(/<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g, '<hr ispageseparator="true"/>'); //替换分页符标签，用于编辑器展示
				ueditorService.transcodeVideo(scope.list.articleHtmlCon).then(function(html) {
					html ? scope.list.articleHtmlCon = html : '';
					ue.setContent(scope.list.articleHtmlCon);
					$timeout(function(){
						ueditorService.drawVideoMark(true, true); // 给编辑页的视频打上戳
					},1000);
					//纯文本正文及字数
					var preContent = ue.getContent().replace(/\n/g, "");
					var dom = document.createElement("div");
					dom.innerHTML = preContent;
					preContent = dom.innerText.replace(/\u00a0/g, ' ');
					scope.list.DOCWORDSCOUNT = preContent.replace(/\n/g, "").replace(/\u0020/g, "").replace(/\u3000/g, "").length; //兼容大数据取稿字数算法不同问题
					//纯文本正文及字数
					var preResult = $sce.getTrustedHtml("<div class='display_none ueditorMyWordContent'>您已输入{{list.DOCWORDSCOUNT}}个字符</div>");
					var result = $compile(preResult)(scope);
					element.find(".edui-toolbar").append(result);
					var destroyWatch = scope.$watch("list.DOCWORDSCOUNT", function(newValue) {
						if(newValue) {
							$timeout(function() {
								result.removeClass("display_none");
								destroyWatch();
							});
	
						}
					});
				});
				// 这段代码，会有问题，上传的视频文件，ue.getcontent()还是为空
				ueditorService.setPlaceholder(ue, attrs.placeholder);
				ue.getOpt('lang');
				//ue.setHeight(500);
				var promise_keyup;
				var promise_contentChange;
				var promise_mouseup;
				ue.addListener("keyup", function() { //实时双向绑定开始
					bindContent(promise_keyup);
				});
				ue.addListener("contentChange", function() { //实时双向绑定开始
					bindContent(promise_contentChange);
					$timeout(function() {
						var content = ue.getContent();
						if(content !== "") {
							scope.hasContent = true;
						} else {
							scope.hasContent = false;
						}
					});
				});
				//计算显示字数，并显示出来
				var iframe = domUtils.getWindow(ue.document).frameElement;
				domUtils.on(ue.body, "mouseup", function(event) {
					selectionNumPop(event);
				});
				domUtils.on(ue.body, "keydown", function(event) {
					selectionNumPop(event);
				});
				//显示选中区域的字数
				ue.addListener("selectionchange", function() {
					var selectionStr = this.selection.getText();
					if(selectionStr.length === 0) {
						hideSelectionNum();
					}
				});
				//编辑器失焦是字数显示消失
				ue.addListener("blur", function() {
					hideSelectionNum();
				});
				/**
				 * [showSelectionNum methodname]显示选中字数统计
				 * @return {[type]} [description] null
				 */
				function showSelectionNum(position) {
					var selectionNumDiv = $(document).find(".trs_ueditor_selectionNum");
					selectionNumDiv.css("left", position.left + "px");
					selectionNumDiv.css("top", position.top + "px");
					selectionNumDiv.fadeIn("fast");
				}
				/**
				 * [hideSelectionNum methodname]显示选中字数统计
				 * @return {[type]} [description] null
				 */
				function hideSelectionNum() {
					$(document).find(".trs_ueditor_selectionNum").fadeOut('fast');
				}
				/**
				 * [showSelectionNum methodname]显示选中字数统计
				 * @return {[type]} [description] null
				 */
				function selectionNumPop(event) {
					var selectionStr = ue.selection.getText();
					if(selectionStr.length !== 0) {
						var selectionNumDiv = $(document).find(".trs_ueditor_selectionNum");
						var position = {};
						/*var e = event;
						var sh = $window.pageYOffset || $window.document.documentElement.scrollTop || $window.document.body.scrollTop || 0;
						position.left = (e.clientX - 40 < 0) ? e.clientX + 20 : e.clientX - 40;
						position.top = (e.clientY - 40 < 0) ? e.clientY + sh + 20 : e.clientY + sh - 40;*/
						selectionNumDiv.html("已选中" + selectionStr.replace(/&nbsp;/g, "").replace(/\u00a0/g, "").replace(/\u3000/g, "").replace(/\n/, "").length + "个字");
						showSelectionNum(position);
					} else {
						hideSelectionNum();
					}
				}
				compareLocalAndServe().then(function() {
					scope.promise = $interval(localcache, 120000);
				});
				//MLFWEB-5014 修复全屏的bug
				ue.addListener('fullscreenchanged', function(type, bfullscreen) {
					scope.infullscreen = bfullscreen;
					var $iframeHolder = $('.edui-editor-iframeholder');
					$iframeHolder.css("width", "100%");
					//全屏需要出滚动条
					//$timeout(function() {
					//});
					//
					var doc = $iframeHolder.find("iframe")[0].contentWindow.document;
					doc.body.style.overflow = bfullscreen ? 'auto' : 'auto';
					if(!bfullscreen) {
						doc.body.style.height = "initial";
					}
					$timeout(function() {
						ue.selection.getRange().collapsed = true;
						ue.selection.getRange().startOffset = ue.selection.getRange().endOffset;
						ue.execCommand("inserthtml", "<trsfullscreen></trsfullscreen>");
						var doms = doc.getElementsByTagName('trsfullscreen');

						for(var index = 0; index < doms.length; index++) {
							doms[index].parentNode.removeChild(doms[index]);
						}

						ue.fireEvent("contentChange");
					});
				});
			});
			scope.$on("$destroy", function() {
				$interval.cancel(scope.promise); //销毁定时事件
			});
			/**
			 * [initStatus methodname]绑定数据和编辑器内容
			 * @return {[type]} [description] null
			 */
			function bindContent(promise) {
				if(promise) {
					$timeout.cancel(promise);
					promise = null;
				}
				promise = $timeout(function() {
					var content = ue.getContent();
					var preContent = content.replace(/\n/g, "");
					var dom = document.createElement("div");
					dom.innerHTML = preContent;
					preContent = dom.innerText.replace(/\u00a0/g, ' ');
					scope.list.DOCWORDSCOUNT = preContent.replace(/\n/g, "").replace(/\u0020/g, "").replace(/\u3000/g, "").length; //兼容大数据取稿字数算法不同问题
				}, 500);
				return promise;
			}
			/**
			 * [localcache methodname]本地保存
			 * @return {[type]} [description] null
			 */
			function localcache() {
				ueditorService.saveToLocal(scope.list.id, scope.versionid);
			}
			/**
			 * [compareLocalAndServe methodname]比较本地和服务器正文版本是否相同
			 * @return {[type]} [description] null
			 */
			function compareLocalAndServe() {
				scope.versionid = scope.versionid === "" ? "0" : scope.versionid;
				var deffer = $q.defer();
				var htmlContent = ue.getContent();
				var localContentArray = localStorageService.get("ueLocalVersion");
				var localContent;
				if(localContentArray === null) {
					deffer.resolve();
				} else {
					for(var i = 0; i < localContentArray.length; i++) {
						if(localContentArray[i].ID === (scope.list.id + "") && (angular.isUndefined(scope.versionid) || angular.isUndefined(localContentArray[i].VERSIONID) || localContentArray[i].VERSIONID === scope.versionid)) {
							localContent = localContentArray[i].CONTENT;
						}
					}
					if(angular.isUndefined(localContent)) {
						deffer.resolve();
					} else if(htmlContent === localContent) {
						deffer.resolve();
					} else if(htmlContent !== localContent) {
						var tipInfo = "检测到服务器稿件正文与本地稿件正文有差异，是否恢复本地版本正文？";
						modalDialog.confirmModal("恢复本地版本", tipInfo, function() {
							ue.setContent(localContent);
							deffer.resolve();
						}, function() {
							deffer.resolve();
						});
					}
				}
				return deffer.promise;
			}
			scope.$watch("list.id", function(newValue, oldValue) { //新建稿件时，将ID为0的本地版本内容迁到新生成的ID的稿件正文中
				var newId = newValue + "";
				var oldId = oldValue + "";
				if(newId !== oldId && oldId === "0") {
					var localContentArray = localStorageService.get("ueLocalVersion");
					var newContent = "";
					for(var i = 0; i < localContentArray.length; i++) {
						if(localContentArray[i].ID === "0") {
							newContent = localContentArray[i].CONTENT;
							localContentArray.splice(i, 1);
							break;
						}
					}
					localStorageService.set("ueLocalVersion", localContentArray);
				}
			});
			/**
			 * [insertImg description] 插入图片或改变图片属性
			 * @param  {[type]} imgInfo [description] 图片信息
			 * @return {[type]}         [description]
			 */
			function insertImg(imgInfo) {
				ueditorService.basicUploadPic(imgInfo).then(function(data) {
					var dom = document.createElement("div");
					dom.innerHTML = data;
					var index = 0;
					var $imgs = $(dom).find("img");
					$imgs.each(function(i) {
						var self = this;
						this.onload = function() {
							if(this.width > 550)
								$(this).attr("width", "550");
							index++;
							if(index === $imgs.length) {
								ue.execCommand("inserthtml", dom.innerHTML);
								ue.fireEvent("contentChange");
							}
						};
					});
				});
			}
			/*编辑器新增按钮开始*/
			//从按钮服务中调用的按钮方法
			var ueditorBtnFunction = ["insertImage", "pageBreak", "recoverLocalVersion", "insertVideo", "insertAudio"];
			// var ueditorBtnFunction = ["insertImage", "pageBreak", "recoverLocalVersion"];
			
			//这边根据传进来的type选项 加载不同的按钮
			// debugger;
			if(scope.type === "newNotice") {
				ueditorBtnFunction.splice(2, 1);
				ueditorBtnFunction.splice(2, 2);
			}
			if(scope.type === "lishui") {
				ueditorBtnFunction.splice(3, 2);
			}
			if(scope.type === "video" || scope.type === "lishui" || scope.type === "image") {
				ueditorBtnFunction.splice(3, 2);
			}
			if(scope.type === "image") {
				ueditorBtnFunction.splice(0, 1);
			}
				//暴露在编辑器中的按钮对象
				var ueditorBtn = [{
					insertImage: ""
				}, {
					pageBreakBtn: ""
				}, {
					recoverLocalVersion: ""
				}, {
					insertCloudPlateFlagBtn: ""
				}, {
					insertVideo: ""
				}, {
					insertAudio: ""
				}];
			//遍历按钮方法，实例化按钮，并返回按钮对象
			for(var i = 0; i < ueditorBtnFunction.length; i++) {
				// debugger;
				ueditorBtnService[ueditorBtnFunction[i]](UE, scope, ue, i).then(function(btn) {
					ueditorBtn[btn.index][ueditorBtnFunction[btn.index] + "Btn"] = btn.obj;
				});
			}
			//监听源码模式下按钮变灰，非源码模式下按钮复原
			ue.addListener('sourcemodechanged', function(t, enabled) {
				var i;
				if(enabled === true) {
					for(i = 0; i < ueditorBtnFunction.length; i++) {
						if(ueditorBtn[i][ueditorBtnFunction[i] + "Btn"] !== "") {
							ueditorBtn[i][ueditorBtnFunction[i] + "Btn"].addState('disabled');
						}
					}
				} else {
					for(i = 0; i < ueditorBtnFunction.length; i++) {
						if(ueditorBtn[i][ueditorBtnFunction[i] + "Btn"] !== "") {
							ueditorBtn[i][ueditorBtnFunction[i] + "Btn"].removeState('disabled');
						}
					}
				}
			});
			/*编辑器新增按钮结束*/
			//判断结束
			if(angular.isDefined(scope.customButton)) {
				UE.registerUI(scope.customButton.name, function(editor, uiName) {
					//注册按钮执行时的command命令，使用命令默认就会带有回退操作
					editor.registerCommand(uiName, {
						execCommand: function() {}
					});
					var btn = new UE.ui.Button({
						//按钮的名字
						name: scope.customButton.name,
						//提示
						title: scope.customButton.title,
						//需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
						cssRules: 'background-position: -559px -39px;',
						//点击时执行的命令
						onclick: function() {
							scope.customButtonFn();
						}
					});
					return btn;
				});
			}
			//图片工具条代码开始
			var domUtils = baidu.editor.dom.domUtils;
			var popup = new baidu.editor.ui.Popup({
				editor: ue,
				content: '',
				className: 'edui-bubble',
				_onImgEditButtonClick: function(name) {
					this.hide();
					if(name == "insertimageDialog") {
						var imgInfo = popup.anchorEl;
						insertImg(imgInfo);
					} else {
						ue.ui._dialogs[name] && ue.ui._dialogs[name].open();
					}
				},
				//圖片编辑
				_onImgclipping: function() {
					this.hide();
					var img = popup.anchorEl;
					var image = {
						PERPICURL: $(img).attr("src"),
						APPFILE: angular.isDefined($(img).attr("uploadpic")) ? $(img).attr("uploadpic") : $(img).attr("src").split("/")[$(img).attr("src").split("/").length - 1] //angular.isDefined($(img).attr("oldsrc")) ? $(img).attr("oldsrc") : $(img).attr("uploadpic")
					};
					scope.photoFileName = image.APPFILE;

					//图片裁剪临时放这 --start
					editPictureService.newCropper($(img).attr("src")).then(function(data) {
						debugger;
						var myImg = new Image();
						myImg.src = data.imgSrc;
						myImg.onload = function() {
							//如果原图很大的话，添加水印之后，图片就变小了，这个不合理。
							//应该是水印后图片超过了编辑器中图片的大小，则需要减小之编辑器图片大小
							//myHeight = myImg.naturalWidth > 550 ? 550 : 'auto';                            
							//myWidth = myImg.width > 550 ? 550 : 'auto';
							//var offsetWidth = parseInt(img.offsetWidth, 10);
							//myWidth = myImg.width //> offsetWidth ? (offsetWidth + "px") : myImg.width;
							var aspectRatio = myImg.width / myImg.height;
							var width = myImg.width > 550 ? 550 : myImg.width;
							var height = myImg.width > 550 ? 550 / aspectRatio : myImg.height;
							domUtils.setAttributes(img, {
								"src": data.imgSrc,
								"uploadpic": data.imgName,
								"_src": data.imgSrc,
								"width": width + "px",
								"height": height + "px"
								//"height":myImg.height
								//width: myWidth,
								//height: 'inital'
							});
							domUtils.setStyles(img, {
								"width": width + "px",
								"height": height + "px"
							});
							//img.style.width = myWidth;
							//img.style.height = 'auto';
							ue.fireEvent('contentchange');
						};
					});
					//图片裁剪临时放这 --end

					/*editPictureService.editPicture(image, function(params) {
					    var myImg = new Image();
					    var sFileName = params.imgName || params.FN;
					    var imageUrl = "/wcm/file/read_image.jsp?FileName=" + sFileName; //文件没有保存之后，是U0开头
					    if (sFileName.match(/^W0/)) {
					        imageUrl = ["/webpic/", sFileName.substring(0, 8), "/", sFileName.substring(0, 10), "/", sFileName].join("");
					        //imageUrl += "?r=" + new Date().getTime(); //添加水印之后，图片名称不变，防止图片不刷新
					    }
					    myImg.src = imageUrl;
					    myImg.onload = function() {
					        //如果原图很大的话，添加水印之后，图片就变小了，这个不合理。
					        //应该是水印后图片超过了编辑器中图片的大小，则需要减小之编辑器图片大小
					        //myHeight = myImg.naturalWidth > 550 ? 550 : 'auto';                            
					        //myWidth = myImg.width > 550 ? 550 : 'auto';
					        //var offsetWidth = parseInt(img.offsetWidth, 10);
					        //myWidth = myImg.width //> offsetWidth ? (offsetWidth + "px") : myImg.width;
					        var aspectRatio = myImg.width / myImg.height;
					        var width = myImg.width > 550 ? 550 : myImg.width;
					        var height = myImg.width > 550 ? 550 / aspectRatio : myImg.height;
					        domUtils.setAttributes(img, {
					            "src": imageUrl,
					            "uploadpic": sFileName,
					            "_src": imageUrl,
					            "width": width + "px",
					            "height": height + "px"
					            //"height":myImg.height
					            //width: myWidth,
					            //height: 'inital'
					        });
					        domUtils.setStyles(img, {
					            "width": width + "px",
					            "height": height + "px"
					        });
					        //img.style.width = myWidth;
					        //img.style.height = 'auto';
					        ue.fireEvent('contentchange');
					    };
					});*/
				},
				/*扩展方法，设置图片区域自定义尺寸*/
				_onImgResize: function(value) {
					value = value.replace("px", "");
					if(isNaN(value)) {
						this.hide();
						return;
					} else {
						var img = popup.anchorEl;
						var percent = 0;
						if(img.naturalWidth > 0) {
							percent = img.naturalHeight / img.naturalWidth;
						}
						domUtils.setAttributes(img, {
							'width': value + 'px',
							'height': (value * percent == 0 ? '' : value * percent + 'px')
						});
						domUtils.setStyles(img, {
							'width': value + 'px',
							'height': (value * percent == 0 ? '' : value * percent + 'px')
						});
					}
					domUtils.on(document.body, "keydown");
					this.hide();
				},
				_enterEvent: function(_dom) {
					/*domUtils.on(document.body, "keydown", function(evt) {
					    if (evt.keyCode == 13) { //回车事件
					        popup._onImgResize(_dom.value);
					    }
					});*/
					popup._onImgResize(_dom.value + "px");
				},
				/*扩展方法，设置图片区域指定尺寸*/
				_onImgSetSize: function(value) {
					var img = popup.anchorEl;

					//img.src = "";
					//img.setAttribute("uploadpic", "");

					var percent = 0;
					if(img.naturalWidth > 0) {
						percent = img.naturalHeight / img.naturalWidth;
					}

					if(img && img.tagName == "IMG") {
						switch(value) {
							case 'small':
								domUtils.setAttributes(img, {
									'width': '100px',
									'height': (100 * percent == 0 ? '' : 100 * percent + 'px')
								});
								domUtils.setStyles(img, {
									'width': '100px',
									'height': (100 * percent == 0 ? '' : 100 * percent + 'px')
								});
								break;
							case 'middle':
								domUtils.setAttributes(img, {
									'width': '300px',
									'height': (300 * percent == 0 ? '' : 300 * percent + 'px')
								});
								domUtils.setStyles(img, {
									'width': '300px',
									'height': (300 * percent == 0 ? '' : 300 * percent + 'px')
								});
								break;
							case 'big':
								domUtils.setAttributes(img, {
									'width': '500px',
									'height': (500 * percent == 0 ? '' : 500 * percent + 'px')
								});
								domUtils.setStyles(img, {
									'width': '500px',
									'height': (500 * percent == 0 ? '' : 500 * percent + 'px')
								});
								break;
							case 'original':
								domUtils.setAttributes(img, {
									'width': (img.naturalWidth ? img.naturalWidth + 'px' : ''),
									'height': (img.naturalHeight ? img.naturalHeight + 'px' : '')
								});
								domUtils.setStyles(img, {
									'width': (img.naturalWidth ? img.naturalWidth + 'px' : ''),
									'height': (img.naturalHeight ? img.naturalHeight + 'px' : '')
								});
								break;
							case 'border':
								if(img.border != "1") {
									img.border = "1";
								} else {
									img.border = "";
								}

								break;
						}
					}
					ue.fireEvent("contentChange");
					//this.hide();
				},
				_setAsOutlinepics: function(imgSrc) {
					var splitString = imgSrc.indexOf("FileName=") > 0 ? "FileName=" : "/";
					var imgSrcArray = imgSrc.split(splitString);
					var imgName = imgSrcArray[imgSrcArray.length - 1];
					var flag = true;
					var newOutlinePic = {
						APPDESC: imgName,
						APPFILE: imgName,
						PERPICURL: "/wcm/openapi/readimg?ScaleWidth=600&FileName=" + imgName
					};
					for(var i = 0; i < scope.list.OUTLINEPICS.length; i++) {
						var outlinePic = scope.list.OUTLINEPICS[i];
						if(outlinePic.PERPICURL === "" || angular.isUndefined(outlinePic.PERPICURL)) {
							flag = false;
							scope.list.OUTLINEPICS.splice(i, 1, newOutlinePic);
							break;
						}
					}
					if(flag) {
						scope.list.OUTLINEPICS.push(newOutlinePic);
					}
					modalDialog.alertType("设为导图成功", "", "success", false);
				}
			});
			popup.render();
			UE.plugins["addborder"] = function() {
				var me = this;
				//创建一个改变图片边框的命令
				me.commands["addborder"] = {
					execCommand: function() {
						//获取当前选区
						var range = me.selection.getRange();
						//选区没闭合的情况下操作
						if(!range.collapsed) {
							//图片判断
							var img = range.getClosedNode();
							if(img && img.tagName == "IMG") {
								//点击切换图片边框
								img.style.border = img.style.borderWidth == "5px" ? "1px" : "5px solid red";
							}
						}
					}
				};
				//注册一个触发命令的事件，同学们可以在任意地放绑定触发此命令的事件
				me.addListener('selectionchange', function(t, causeByUi) {
					if(!causeByUi) return;
					var html = '',
						str = "",
						img = ue.selection.getRange().getClosedNode(),
						dialogs = ue.ui._dialogs;
					if(img && img.tagName == 'IMG' && img.getAttribute("videoId")) {
						playVideoService.openPlayVideoPage(img.getAttribute("videoId"), 'video');
					}
					if(img && img.tagName == 'IMG' && img.getAttribute("audioId")) {
						playVideoService.openPlayVideoPage(img.getAttribute("audioId"), 'audio');
					}
					if(img && img.tagName == 'IMG' && !img.getAttribute("videoId") && !img.getAttribute("audioId")) {
						var dialogName = 'insertimageDialog';
						if(img.className.indexOf("edui-faked-video") != -1 || img.className.indexOf("edui-upload-video") != -1) {
							dialogName = "insertvideoDialog"
						}
						if(img.className.indexOf("edui-faked-webapp") != -1) {
							dialogName = "webappDialog"
						}
						if(img.src.indexOf("http://api.map.baidu.com") != -1) {
							dialogName = "mapDialog"
						}
						if(img.className.indexOf("edui-faked-music") != -1) {
							dialogName = "musicDialog"
						}
						if(img.src.indexOf("http://maps.google.com/maps/api/staticmap") != -1) {
							dialogName = "gmapDialog"
						}
						if(img.getAttribute("anchorname")) {
							dialogName = "anchorDialog";
							html = popup.formatHtml(
								'<nobr>' + ue.getLang("property") + ': <span onclick=$$._onImgEditButtonClick("anchorDialog") class="edui-clickable">' + editor.getLang("modify") + '</span>&nbsp;&nbsp;' +
								'<span onclick=$$._onRemoveButtonClick(\'anchor\') class="edui-clickable">' + editor.getLang("delete") + '</span></nobr>');
						}
						if(img.getAttribute("word_img")) {
							//todo 放到dialog去做查询
							ue.word_img = [img.getAttribute("word_img")];
							dialogName = "wordimageDialog"
						}
						str = '<nobr>' +
							'&nbsp;<span><input onchange=$$._enterEvent(this) onclick=this.focus();this.select(); type="text" style="width:40px" value="' + img.clientWidth + '">px</span>&nbsp;&nbsp;' +
							'<span onclick=$$._onImgSetSize("small") class="edui-clickable smallpic">' + "▪" + '</span>' +
							'<span onclick=$$._onImgSetSize("middle") class="edui-clickable normal">' + "■" + '</span>' +
							'<span onclick=$$._onImgSetSize("big") class="edui-clickable bigpic">' + "█" + '</span>' +
							'<span onclick=$$._onImgSetSize("original") class="edui-clickable ori-pic">' + '原始大小' + '</span> ' +
							'<span onclick=$$._onImgSetSize("border") class="edui-clickable pic-border">' + "边框" + '</span> ' +
							'<span onclick=$$._onImgclipping() class="edui-clickable pic-cut">' + "裁剪" + '</span> ' +
							'<span onclick="$$._onImgEditButtonClick(\'' + dialogName + '\');" class="edui-clickable pic-pro">' + '属性' + '</span> ';
						//网站渠道增加设为导图功能（编辑器中的图片可以直接设为导图）
						if(scope.type === "website") {
							str += '<span onclick="$$._setAsOutlinepics(\'' + img.getAttribute("src") + '\');" style="width:64px" class="edui-clickable pic-pro">' + '设为导图' + '</span>';
						}
						str += "</nobr>";
						/*
						str = '<nobr>' + editor.getLang("property") + ': ' +
						    '<span onclick=$$._onImgSetFloat("none") class="edui-clickable">' + editor.getLang("default") + '</span>&nbsp;&nbsp;' +
						    '<span onclick=$$._onImgSetFloat("left") class="edui-clickable">' + editor.getLang("justifyleft") + '</span>&nbsp;&nbsp;' +
						    '<span onclick=$$._onImgSetFloat("right") class="edui-clickable">' + editor.getLang("justifyright") + '</span>&nbsp;&nbsp;' +
						    '<span onclick=$$._onImgSetFloat("center") class="edui-clickable">' + editor.getLang("justifycenter") + '</span>&nbsp;&nbsp;' +
						    '<span onclick="$$._onImgEditButtonClick(\'' + dialogName + '\');" class="edui-clickable">' + editor.getLang("modify") + '</span></nobr>';
						*/
						!html && (html = popup.formatHtml(str));
						if(html) {
							popup.getDom('content').innerHTML = html;
							popup.anchorEl = img;
							//当图片同时存在超链接时，与超链接的工具栏分开展示
							if(!!ue.queryCommandValue('link')) {
								popup.showAnchor(popup.anchorEl, undefined, 32);
							} else {
								popup.showAnchor(popup.anchorEl);
							}
						} else {
							popup.hide();
						}

					}
				});
			};
			//图片工具条代码结束

		}
	};
}]);
